import { useState } from "react";
import PropTypes from "prop-types";
import NavDropdown from "./nav-dropdown";
import NavDrawer from "./nav-drawer";
import { connect } from "react-redux";
import { flagsAndExperimentNames } from "rtr-constants";
import PlusIcon from "images/sprites/reb/svg/plus-icon.svg";
import MinusIcon from "images/sprites/reb/svg/minus-icon.svg";

const NavItems = props => {
  const { items, parentClass, childClass, enableNavDropdown, isMobile } = props;
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [drawerPosition, setDrawerPosition] = useState(null);
  const [openMobileDrawer, setOpenMobileDrawer] = useState(false);

  const handleMouseEnter = (index, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setDrawerPosition({
      top: rect.bottom, // bottom of link
      left: rect.left,
      width: rect.width,
    });
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
    setDrawerPosition(null);
  };

  return (
    <nav>
      <ul className={parentClass} data-test-id="nav-items">
        {items?.length > 0 &&
          items.map((item, index) => (
            /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */
            <li
              className={`${childClass} ${hoveredIndex === index ? "hovered" : ""}`}
              key={`nav-item-${item.label.replace(" ", "_")}`}
              onMouseEnter={e => handleMouseEnter(index, e)}
              onMouseLeave={handleMouseLeave}>
              <a
                href={item.url}
                className={`nav-link block duration-200 sm:hover:text-darkGray nav-item w-full ${
                  isMobile ? "p-4 grid grid-cols-[1fr_auto] items-center" : ""
                }`}>
                <span className="nav-item-label" style={{ color: item.color }}>
                  {item.label}
                </span>

                {/* Expand nav dropdown on mobile */}
                {enableNavDropdown && item["sub-links"] && isMobile && (
                  <button
                    className="plus-minus block sm:hidden inline-block right-0"
                    data-test-id="nav-drawer-toggle"
                    onClick={e => {
                      e.preventDefault();

                      setOpenMobileDrawer(!openMobileDrawer);
                    }}>
                    {isMobile && openMobileDrawer ? (
                      <MinusIcon className="w-4 h-4" />
                    ) : (
                      <PlusIcon className="w-4 h-4" />
                    )}
                  </button>
                )}
              </a>
              {enableNavDropdown && hoveredIndex === index && item["sub-links"] && (
                <NavDropdown isOpen={hoveredIndex === index} position={drawerPosition}>
                  <ul className="text-left p-0">
                    {item["sub-links"].map((subLink, subIndex) => (
                      <li className="text-md pb-4" key={`nav-sub-item-${subIndex}`}>
                        <a href={subLink.url} className="!text-black hover:underline">
                          <span className="sub-nav-item-label" style={{ color: item.color }}>
                            {subLink.label}
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </NavDropdown>
              )}

              {enableNavDropdown && isMobile && item["sub-links"] && (
                <NavDrawer isOpen={openMobileDrawer}>
                  <ul className="text-left p-0">
                    {item["sub-links"].map((subLink, subIndex) => (
                      <li className="text-md" key={`nav-sub-item-${subIndex}`}>
                        <a href={subLink.url} className="!text-black block w-full pb-4">
                          <span className="sub-nav-item-label" style={{ color: item.color }}>
                            {subLink.label}
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </NavDrawer>
              )}
            </li>
          ))}
      </ul>
    </nav>
  );
};

const mapStateToProps = state => {
  return {
    enableNavDropdown: state.flagsAndExperiments?.[flagsAndExperimentNames.CATALOG_SERVICES_ENABLE_NAV_DROPDOWN],
  };
};

NavItems.propTypes = {
  items: PropTypes.array,
  parentClass: PropTypes.string,
  childClass: PropTypes.string,
  enableNavDropdown: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default connect(mapStateToProps)(NavItems);
